// extracted by mini-css-extract-plugin
export var active = "_ca-c";
export var compactArrow = "_ca-5";
export var container = "_ca-0";
export var dot = "_ca-b";
export var dotContainer = "_ca-a";
export var hoverArrowButton = "_ca-7";
export var hoverArrowContainer = "_ca-6";
export var leftHoverArrowContainer = "_ca-8 _ca-6";
export var rightHoverArrowContainer = "_ca-9 _ca-6";
export var slide = "_ca-4";
export var sliderContainer = "_ca-1";
export var sliderContainerVisibleOverflow = "_ca-2";
export var sliderOverflow = "_ca-3";
export var vignetteBoth = "_ca-f";
export var vignetteLeft = "_ca-e";
export var vignetteRight = "_ca-d";